import React from 'react'
import { Updater, fromJSX, Widget, any } from 'widgets-for-react'
import { InviewProps } from '../blocksState'
import { CourseSearchBarLayout } from './courseSearchBarLayout'
import {
  CourseSearchBarState
} from './courseSearchBarState'

export type CourseSearchBarBlock = {
  index: number
  inview?: InviewProps
  courseSearchBarState: CourseSearchBarState
}

export const courseSearchBarWidget = (
  block: CourseSearchBarBlock
): Widget<Updater<CourseSearchBarState>> => {
  return any<Updater<CourseSearchBarState>>([
    fromJSX(setState => (
      <CourseSearchBarLayout
        {...block}
        query={block.courseSearchBarState.query}
        setQuery={(newQuery: string) =>
          setState(s => ({ ...s, query: newQuery }))
        }
      />
    ))
  ])
}
